import dynamic from 'next/dynamic';

/*
  Importing/exporting this as Client Side Rendered component to prevent SSR/CSR flicker.
  Without this, all slides/items are rendered side-by-side on page load,
  and will flicker into the "correct" view once the Carousel has initialised.
  This ensures that server side does not attempt to render the Carousel.
*/
const EmblaCarouselCSR = dynamic(() => import('./EmblaCarousel'), {
  ssr: false,
});

export { EmblaCarouselCSR as default };
